/**
 * Страницы начинаются с 0. Первый запрос зависит от флага hasPagination
 * Если карта видна на странице, грузим отели без пагинации
 * Если карта не видна, например, в мобильной версии получаем 100 отелей
 */
export const PAGINATION = {
  PAGE_LIMIT: 100,
  PAGE_NUMBER: 0,
  VISIBLE_LIMIT: 5,
};
